module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/hooks-lore-hook-reducers-installation.json
// module id = 2229
// module chunks = 250808499710311